/**
 * ViewWizardSteps - Step indicator for view creation wizard
 *
 * Displays progress through wizard steps with visual indicators
 */

import React from 'react';
import { Check } from 'lucide-react';

interface ViewWizardStepsProps {
  currentStep: number;
  steps: string[];
}

export const ViewWizardSteps: React.FC<ViewWizardStepsProps> = ({ currentStep, steps }) => {
  return (
    <div className="flex justify-between mt-4">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;
        const isUpcoming = stepNumber > currentStep;

        return (
          <div key={stepNumber} className="flex flex-col items-center flex-1 relative">
            {/* Connector line */}
            {index < steps.length - 1 && (
              <div
                className={`absolute top-5 left-1/2 w-full h-0.5 ${
                  isCompleted ? 'bg-primary' : 'bg-muted'
                }`}
                style={{ zIndex: 0 }}
              />
            )}

            {/* Step circle */}
            <div className="relative z-10 mb-2">
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center border-2 transition-colors
                  ${isCompleted ? 'bg-primary border-primary text-primary-foreground' : ''}
                  ${isCurrent ? 'bg-primary border-primary text-primary-foreground' : ''}
                  ${isUpcoming ? 'bg-background border-muted text-muted-foreground' : ''}
                `}
              >
                {isCompleted ? (
                  <Check className="h-5 w-5" />
                ) : (
                  <span className="text-sm font-semibold">{stepNumber}</span>
                )}
              </div>
            </div>

            {/* Step label */}
            <div className="text-center">
              <p
                className={`
                  text-xs font-medium
                  ${isCurrent ? 'text-foreground' : ''}
                  ${isCompleted ? 'text-foreground' : ''}
                  ${isUpcoming ? 'text-muted-foreground' : ''}
                `}
              >
                {step}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
